var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service"},[_c('iframe',{attrs:{"src":"https://doc.k2046.com/","frameborder":"0"}})])
}]

export { render, staticRenderFns }